import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { CanActivateFn, GuardResult, MaybeAsync } from '@angular/router';
import { from, isObservable, Observable, of } from 'rxjs';
import { concatMap, last, takeWhile } from 'rxjs/operators';

function toObservable<T>(value: MaybeAsync<T>): Observable<T> {
  if (isObservable(value)) {
    return value;
  }

  if (value instanceof Promise) {
    return from(value);
  }

  return of(value);
}

export function guardsInOrder(guards: CanActivateFn[]): CanActivateFn {
  return (route, state) => {
    if (guards.length === 0) {
      return true;
    }

    const injector = inject(EnvironmentInjector);

    return from(guards).pipe(
      concatMap((guard) => toObservable(runInInjectionContext(injector, () => guard(route, state)))),
      takeWhile((result: GuardResult) => result === true, true),
      last()
    );
  };
}
